import {getConfig} from './config';

export const http = {
  async get(url: string) {
    const res = await getConfig().request.get(url, {headers: getHeaders()});
    return res.data?.data || res.data;
  },

  async post(url: string, data: any) {
    const res = await getConfig().request.post(url, data, {headers: getHeaders()});
    return res.data?.data || res.data;
  },

  async postFormData(url: string, data: any) {
    const res = await getConfig().request.postFormData(url, data, {headers: getHeaders()});
    return res.data?.data || res.data;
  }
};

function getHeaders() {
  return {
    'apikeyid': 'sk-d5a30863f6f34def99a803ea907de87b'
  };
}